import React from "react";

function Tabs({ steps, stepNumber }) {
  return (
    <div className="squares-container">
      {steps?.map((step, index) => (
        <span
          key={step.key}
          className="square"
          style={{
            backgroundColor:
              stepNumber === index ? "var(--primary-color)" : "#f2f2f2",
            color: stepNumber === index ? "#ffffff" : "#a6a6a6",
          }}
        >
          {step.props?.name}
        </span>
      ))}
    </div>
  );
}

export default Tabs;
